import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Typography, Box, makeStyles, Divider } from "@material-ui/core";
import SlowMotionVideoIcon from '@material-ui/icons/SlowMotionVideoSharp';

const useStyles = makeStyles((theme) => ({
  card: {
    flexGrow: 1,
    background: theme.palette.primary.main,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  textColor: {
    color: theme.palette.common.white+"!important"
  },
  ctaButton: {
    margin: 0
  },
  root: {
    color: "white",
    border: '1px solid white',
  },
  divider: {
    backgroundColor: "white",
    marginTop: 20,
    marginBottom: 20,
    width: '90%',
    height: 1,
  }
}));

export default function CtaCard({ name, text, ctaText, link }) {
  const classes = useStyles()
  const ctaProps = {
    variant: "outlined",
    className: classes.root,
    fullWidth: false,
    endIcon: <SlowMotionVideoIcon />,
    size: 'large'
  };

  return (
    <Box className={classes.card} display='flex' flexDirection='column' justifyContent='center' alignItems='center' textAlign='center' color="white">
      <Box><Typography variant="h4">{name}</Typography></Box>
      <Divider variant="fullWidth" className={classes.divider} />
      <Box mb={2} flexGrow={1}><Typography variant="body1" className={classes.textColor}>{text}</Typography></Box>
      <Button component={Link} to={link} {...ctaProps}>
        {ctaText}
      </Button>
    </Box>
  );
}

CtaCard.propTypes = {
  // icon: PropTypes.element.isRequired,
  text: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
};
